import { Button, Chip, Dialog, Paper, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableRow, TableHead, TableContainer } from '@mui/material';
import { trackActivity } from '../../../utils/mixpanel';
import NumericLabel from 'react-pretty-numbers';

const EventBalanceModal = ({ eventBalance, onToggleModal }) => {
      const handleItemClicked = (page_type) => {
      trackActivity("Item Clicked", { page_title: `Module Balance`, page_type: page_type });
      };
  return (
    <>
      <Dialog open={eventBalance?.modal} aria-labelledby="scroll-dialog-title" className='add-lease-dialog' maxWidth="xs" fullWidth >
        <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header' id="scroll-dialog-title">Module Balance</DialogTitle>
        <DialogContent dividers={true} sx={{ p: 2, display: 'flex', flexDirection: 'column', }} >
          <TableContainer component={Paper}
            elevation={0}
            sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, overflow: 'hidden', }}>
            <Table
              sx={{
                '& th, & td': { px: 1, py: 1 },
                '& tbody tr:last-of-type td': { borderBottom: 'none', pb: 0 },
                '& thead th': { py: 0.20, color: 'common.white', fontWeight: 600, bgcolor: 'primary.main' },
              }}
            >
              <TableHead>
                <TableRow sx={{ backgroundColor: "#1976d2" }}>
                  <TableCell sx={{ color: "white", fontWeight: 600 }}>Module</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: 600 }}>Fund</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: 600 }}>Percentage(%)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {eventBalance?.data?.fund_allocation?.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      {row?.module_name ? row?.module_name : '--'}
                      {row?.is_non_llp && <Chip label="Non LLP" size="small" sx={{ ml: 1, fontSize: '0.7rem', height: '18px', width: '60px' }} />}
                    </TableCell>
                    <TableCell><NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: 'usd', precision: 2, commafy: true, justification: 'L' }}>{row?.amount}</NumericLabel></TableCell>
                    <TableCell>{row?.percentage ? row?.percentage : '--'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </DialogContent>
        <DialogActions>
          <div>
            <div style={{ float: 'right' }}>
              <Button className='cancel-btn' onClick={()=>{onToggleModal(); handleItemClicked("Close Button")}} color="primary" variant='outlined' sx={{ marginRight: "5px" }} size="small">Close</Button>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </>
  )
}
export default EventBalanceModal;







